import { capitalize } from 'lodash';

/**
 * This is a util to format product gender as necessary.
 * Currently, the main function returns the gender in
 * plural and capitalized format. This creates consistency
 * in what we're sending to Analytics platforms and removes
 * the need for hardcoded values.
 */

const Gender = class {
  static getPluralGender = gender => {
    if (!gender) {
      return gender;
    }

    let formatted = gender;

    if (gender.toLowerCase().includes('men')) {
      formatted = gender.replace("'", '');
      if (formatted.slice(-1) !== 's') {
        formatted += 's';
      }
    }

    return capitalize(formatted);
  };

  static getGenderFromProductName = name => {
    if (!name) {
      return null;
    }

    const firstWord = name.split(' ')[0];

    if (firstWord.toLowerCase().includes('men')) {
      return Gender.getPluralGender(firstWord);
    }

    if (firstWord.toLowerCase().includes('small')) {
      return 'Toddler';
    }

    return 'Unisex'; // Defaults to Unisex if it's not a Mens/Womens/Toddler product
  };
};

export default Gender;
